import React from 'react';

import { StructureList } from './StructureList';
import { PLATFORM_NAME } from '../../configs/common';
import { TabHandler } from '../../handlers/TabHandler';

export const Structures: React.FC = () => {
  TabHandler(`List Structure | ${PLATFORM_NAME}`);
  return <StructureList />;
};
